import { InjectionToken } from '@angular/core';
import { IEnvironmentalVariables } from '../environments/variables';

export const Environment = new InjectionToken<IEnvironmentalVariables>('environment');
